"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMaterializedViewProcessWorklease = exports.isMaterializedViewEvaluateWorklease = exports.isMaterializedViewDataAccessorArray = exports.isMaterializedViewDataAccessor = exports.isMaterializedViewRefreshConfig = exports.isMaterializedViewDataConfig = void 0;
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
exports.isMaterializedViewDataConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.MaterializedViewDataConfigSchema,
    typeguardName: 'isMaterializedViewDataConfig',
});
exports.isMaterializedViewRefreshConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.MaterializedViewRefreshConfigSchema,
    typeguardName: 'isMaterializedViewRefreshConfig',
});
exports.isMaterializedViewDataAccessor = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.MaterializedViewDataAccessorSchema,
    typeguardName: 'isMaterializedViewDataAccessor',
});
const isMaterializedViewDataAccessorArray = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isMaterializedViewDataAccessor)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isMaterializedViewDataAccessorArray = isMaterializedViewDataAccessorArray;
exports.isMaterializedViewEvaluateWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.MaterializedViewEvaluateWorklease,
    typeguardName: 'isMaterializedViewEvaluateWorklease',
});
exports.isMaterializedViewProcessWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.MaterializedViewProcessWorklease,
    typeguardName: 'isMaterializedViewProcessWorklease',
});
//# sourceMappingURL=materializedView.js.map